import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { Toast } from './Toast';
import type { Toast as ToastType } from '../../../lib/toast.types';

interface ToastContainerProps {
    toasts: ToastType[];
    onRemove: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemove }) => {
    return (
        <div 
            className="fixed top-16 right-4 z-[100] flex flex-col gap-2 pointer-events-none"
            aria-live="polite"
            aria-atomic="true"
        >
            <AnimatePresence mode="popLayout">
                {toasts.map((toast, index) => (
                    <div key={toast.id} className="pointer-events-auto">
                        <Toast 
                            toast={toast} 
                            onRemove={onRemove} 
                            index={index}
                        />
                    </div>
                ))}
            </AnimatePresence>
        </div>
    );
};